import Vue from 'vue';
import './plugins/vuetify';
import i18n from './localization/i18n';
import App from './App.vue';
import store from './store/Store';
import './filters/translate';
import './filters/ellipsis';
import './filters/localized';
import './filters/noname';
import router from './router';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import vuetify from './plugins/vuetify';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import UUID from "vue-uuid";

// init localization of dates
const locale = window.navigator.language || 'cz';
moment.locale(locale);

// add an icon from Font Awesome to be used
library.add(faUserSecret);

// init extensions
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(Vuetify);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(UUID, { name: 'uuid' });
Vue.component(VueQrcode.name, VueQrcode);

// init Vue
new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');
